export enum AffiliateStatusCodeEnum {
    Pending = "AFPEN",
    Submitted = "AFSUBMIT",
    Complete = "AFCOMP",
    Approved = "AFAPP",
    Declined = "AFDCLD"
}